import { useTranslation } from 'react-i18next';

import { ErrorMessage } from '../../../components/ErrorMessage/ErrorMessage';

import styles from './ForceResetError.module.scss';

interface ForceResetErrorProps {
  message?: string;
  onResetPassword: () => void;
}

/**
 * The force-reset login error with its Reset Password link; it takes the place of the "Forgot password" line.
 * Without a log-in error (opened from the security email) it shows the force-reset message.
 */
export function ForceResetError({ message, onResetPassword }: ForceResetErrorProps) {
  const { t } = useTranslation();

  return (
    // eslint-disable-next-line @sunflower-games/i18n-concat/no-split-sentence -- a full sentence, then the Reset Password link label
    <div className={styles.forceReset} data-testid="force-reset-error">
      <ErrorMessage className={styles.message}>{message || t('auth.forceReset.message')}</ErrorMessage>
      <span className={styles.link} data-testid="force-reset-password-btn" onClick={onResetPassword}>
        {t('auth.forceReset.cta')}
      </span>
    </div>
  );
}
